// // import React, { useState, useEffect } from "react";
// // import {
// //   Box,
// //   Grid,
// // } from "@mui/material";
// // import Production from "./Production";
// // import DistributionGraph from './Distribution';
// // import Inventory from "./Inventory";
// // import styles from "../../styles.module.css";
// // import productMasterService from "../../services/masters/productMaster.Service";
// // import customerMasterService from "../../services/masters/customerMaster.Service";
// // import plantMasterService from "../../services/masters/plantMaster.Service";
// // import depotMasterService from "../../services/masters/depotMaster.Service";
// // import Customerholding from "./Customer_holding";

// // // Example image URL or import your own image
// // const noAccessImage =require("../../images/home.png");

// // const Dashboard = () => {

// //   let userInfo = {};
// //   try {
// //     const login_details = sessionStorage.getItem("loginUser");
// //     if (login_details) {
// //       const userD = JSON.parse(login_details);
// //       userInfo = userD?.result?.userInfo || {};
// //     }
// //   } catch (err) {
// //     console.error("Failed to parse login details", err);
// //   }

// //   // Extract userRole from userInfo
// //   const userRole = userInfo.user_role || "";  
// //   // State for your data
// //   const [customer, setCustomer] = useState([]);
// //   const [product, setProduct] = useState([]);
// //   const [plant, setPlant] = useState([]);
// //   const [depot, setDepot] = useState([]);

// //   useEffect(() => {
// //         async function fetchData() {
// //             try {
// //                 const [
// //                     ProductData,
// //                     customerData,
// //                     PlantData,
// //                     DepotData
// //                 ] = await Promise.all([
// //                     productMasterService.getProductList({ page: 0, size: 999, searchKey: "" }),
// //                     customerMasterService.getCustomerList({ page: 0, size: 999, searchKey: "" }),
// //                     plantMasterService.getPlantList({ page: 0, size: 999, searchKey: "" }),
// //                     depotMasterService.getDepotList({ page: 0, size: 999, searchKey: "" }),
// //                 ]);
// //                 setProduct(ProductData);
// //                 setCustomer(customerData);
// //                 setPlant(PlantData);
// //                 setDepot(DepotData);

// //             } catch (error) {
// //                 console.error("Data fetching failed", error);
// //             }
// //         }
// //         fetchData();
// //     }, []);

  
// //   const allowedRoles = ["management"]; 

// //   return (
// //     <Box className={styles.cts_page} sx={{ padding: '0px !important', margin: '0px !important' }}>
// //       <Box className={styles.body}>
// //         {allowedRoles.includes(userRole) ? (
// //           <Grid container spacing={2} sx={{ mt: 0, pb: 2 }}>
// //             <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
// //               <Production plants={plant} />
// //             </Grid>
// //             <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
// //               <DistributionGraph depots={depot} customers={customer} />
// //             </Grid>
// //             <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
// //               <Inventory plants={plant} depots={depot} customers={customer} products={product} />
// //             </Grid>
// //              <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
// //               <Customerholding plants={plant} depots={depot} customers={customer} products={product} />
// //             </Grid>
// //           </Grid>
// //         ) : (
// //           <Box
// //             display="flex"
// //             justifyContent="center"
// //             alignItems="center"
// //             height="400px"
// //           >
// //             <img src={noAccessImage} alt="Access Denied" />
// //           </Box>
// //         )}
// //       </Box>
// //     </Box>
// //   );
// // };

// // export default Dashboard;

// import React, { useState, useEffect, useMemo } from "react";
// import {
//   Box, Grid, CircularProgress,
//   FormControl, Select, MenuItem, InputLabel,
// } from "@mui/material";
// import { Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS, CategoryScale, LinearScale, BarElement,
//   Title, Tooltip, Legend,
// } from "chart.js";
// import axiosClient from "../../configs/axios";
// import productMasterService from "../../services/masters/productMaster.Service";
// import customerMasterService from "../../services/masters/customerMaster.Service";
// import plantMasterService from "../../services/masters/plantMaster.Service";
// import depotMasterService from "../../services/masters/depotMaster.Service";
// import tri_gases from "../../images/tri_gases.jpeg";

// ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

// // ─── Helpers ──────────────────────────────────────────────────────────────────
// const getLast7Labels = () =>
//   Array.from({ length: 7 }, (_, i) => {
//     const d = new Date();
//     d.setDate(d.getDate() - (6 - i));
//     return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
//   });

// const getLast7Dates = () =>
//   Array.from({ length: 7 }, (_, i) => {
//     const d = new Date();
//     d.setDate(d.getDate() - (6 - i));
//     return d.toISOString().split("T")[0];
//   });

// const greeting = () => {
//   const h = new Date().getHours();
//   if (h < 12) return "Good morning";
//   if (h < 17) return "Good afternoon";
//   return "Good evening";
// };

// const BASE_CHART_OPTS = {
//   maintainAspectRatio: false,
//   responsive: true,
//   scales: {
//     y: {
//       beginAtZero: true,
//       grid: { color: "rgba(0,0,0,0.04)" },
//       ticks: { font: { size: 10, family: "Inter" }, color: "#718096" },
//     },
//     x: {
//       grid: { display: false },
//       ticks: { font: { size: 10, family: "Inter" }, color: "#718096", autoSkip: false, maxRotation: 0 },
//     },
//   },
//   plugins: {
//     legend: { display: false },
//     tooltip: { mode: "index", intersect: false },
//   },
// };

// // ─── Sub-components ────────────────────────────────────────────────────────────

// const KpiCard = ({ icon, label, value, sub, iconBg, valueColor = "#1C3A5E" }) => (
//   <Box sx={{
//     background: "#fff", borderRadius: "12px", padding: "16px 18px",
//     border: "1px solid #E2E8F0", display: "flex", alignItems: "center", gap: "14px",
//     transition: "transform 0.15s, box-shadow 0.15s",
//     "&:hover": { transform: "translateY(-2px)", boxShadow: "0 4px 14px rgba(0,0,0,0.08)" },
//   }}>
//     <Box sx={{
//       width: 44, height: 44, borderRadius: "10px",
//       background: iconBg, display: "flex", alignItems: "center",
//       justifyContent: "center", flexShrink: 0,
//     }}>
//       {icon}
//     </Box>
//     <Box>
//       <Box sx={{ fontSize: "26px", fontWeight: 700, color: valueColor, lineHeight: 1 }}>
//         {value ?? "—"}
//       </Box>
//       <Box sx={{ fontSize: "12px", color: "#718096", mt: "4px", fontWeight: 500 }}>{label}</Box>
//       {sub && <Box sx={{ fontSize: "11px", color: "#A0AEC0", mt: "2px" }}>{sub}</Box>}
//     </Box>
//   </Box>
// );

// const ChartCard = ({ title, sub, badge, badgeColor = "blue", loading, error, filters, legend, children, bottomSlot }) => {
//   const badgeSx = badgeColor === "green"
//     ? { background: "#D4EDDA", color: "#155724" }
//     : { background: "#E6F1FB", color: "#185FA5" };
//   return (
//     <Box sx={{ background: "#fff", borderRadius: "12px", padding: "20px", border: "1px solid #E2E8F0", height: "100%" }}>
//       <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", mb: 1.5 }}>
//         <Box>
//           <Box sx={{ fontSize: "14px", fontWeight: 600, color: "#1C3A5E" }}>{title}</Box>
//           {sub && <Box sx={{ fontSize: "11px", color: "#A0AEC0", mt: "3px" }}>{sub}</Box>}
//         </Box>
//         {badge && (
//           <Box sx={{ fontSize: "11px", fontWeight: 600, padding: "3px 10px", borderRadius: "20px", ...badgeSx }}>
//             {badge}
//           </Box>
//         )}
//       </Box>
//       {filters}
//       {legend && (
//         <Box sx={{ display: "flex", flexWrap: "wrap", gap: "10px", mb: 1.25 }}>
//           {legend.map((l) => (
//             <Box key={l.label} sx={{ display: "flex", alignItems: "center", gap: "5px", fontSize: "11px", color: "#718096" }}>
//               <Box sx={{ width: 10, height: 10, borderRadius: "2px", background: l.color, flexShrink: 0 }} />
//               {l.label}
//             </Box>
//           ))}
//         </Box>
//       )}
//       {loading && (
//         <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "220px" }}>
//           <CircularProgress size={26} sx={{ color: "#2B6CB0" }} />
//         </Box>
//       )}
//       {!loading && error && (
//         <Box sx={{ background: "#FFF5F5", color: "#C53030", borderLeft: "3px solid #FC8181", p: "12px 14px", borderRadius: "6px", fontSize: "13px" }}>
//           {error}
//         </Box>
//       )}
//       {!loading && !error && children}
//       {bottomSlot}
//     </Box>
//   );
// };

// const SectionLabel = ({ children }) => (
//   <Box sx={{ fontSize: "11px", fontWeight: 600, color: "#A0AEC0", letterSpacing: "1.2px", textTransform: "uppercase", mb: 1.5, mt: 0.5 }}>
//     {children}
//   </Box>
// );

// const FilterSelect = ({ label, value, onChange, items, allLabel = "All" }) => (
//   <FormControl size="small" sx={{ minWidth: 140 }}>
//     <InputLabel sx={{ fontSize: "12px", fontFamily: "Inter" }}>{label}</InputLabel>
//     <Select
//       value={value} label={label} onChange={(e) => onChange(e.target.value)}
//       sx={{ fontSize: "12px", fontFamily: "Inter", borderRadius: "8px",
//         "& fieldset": { borderColor: "#E2E8F0" },
//         "&:hover fieldset": { borderColor: "#2B6CB0" },
//         "&.Mui-focused fieldset": { borderColor: "#2B6CB0" },
//       }}
//     >
//       <MenuItem value=""><em>All {allLabel}</em></MenuItem>
//       {items.map((it) => (
//         <MenuItem key={it.value} value={String(it.value)} sx={{ fontSize: "12px" }}>{it.label}</MenuItem>
//       ))}
//     </Select>
//   </FormControl>
// );

// // ─── SVG Icons ─────────────────────────────────────────────────────────────────
// const IcoCylinder = ({ c = "#2B6CB0" }) => (
//   <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2">
//     <rect x="9" y="3" width="6" height="14" rx="2"/>
//     <path d="M9 17H5a2 2 0 00-2 2v0a2 2 0 002 2h14a2 2 0 002-2v0a2 2 0 00-2-2h-4"/>
//   </svg>
// );
// const IcoBox = ({ c = "#155724" }) => (
//   <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2">
//     <path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/>
//     <polyline points="3.27 6.96 12 12.01 20.73 6.96"/>
//     <line x1="12" y1="22.08" x2="12" y2="12"/>
//   </svg>
// );
// const IcoTruck = ({ c = "#856404" }) => (
//   <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2">
//     <rect x="1" y="3" width="15" height="13" rx="1"/>
//     <path d="M16 8h4l3 5v3h-7V8z"/>
//     <circle cx="5.5" cy="18.5" r="2.5"/>
//     <circle cx="18.5" cy="18.5" r="2.5"/>
//   </svg>
// );
// const IcoCustomers = ({ c = "#6B21A8" }) => (
//   <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2">
//     <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/>
//     <circle cx="9" cy="7" r="4"/>
//     <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/>
//   </svg>
// );

// // ─── Progress bar ─────────────────────────────────────────────────────────────
// const ProgBar = ({ label, value, total, color, textColor }) => {
//   const pct = total ? Math.round((value / total) * 100) : 0;
//   return (
//     <Box sx={{ mb: 1.5 }}>
//       <Box sx={{ display: "flex", justifyContent: "space-between", fontSize: "12px", color: "#4A5568", mb: "5px" }}>
//         <span>{label}</span>
//         <span style={{ color: textColor, fontWeight: 600 }}>{value.toLocaleString()} customers</span>
//       </Box>
//       <Box sx={{ height: "8px", background: "#E2E8F0", borderRadius: "4px", overflow: "hidden" }}>
//         <Box sx={{ height: "100%", width: `${pct}%`, background: color, borderRadius: "4px", transition: "width 0.6s ease" }} />
//       </Box>
//     </Box>
//   );
// };

// // ════════════════════════════════════════════════════════════════════════════
// //  MAIN DASHBOARD
// // ════════════════════════════════════════════════════════════════════════════
// const Dashboard = () => {
//   // ── Session ──
//   let userInfo = {};
//   try {
//     const ld = sessionStorage.getItem("loginUser");
//     if (ld) userInfo = JSON.parse(ld)?.result?.userInfo || {};
//   } catch {}
//   const userRole = userInfo.user_role || "";
//   const userName = userInfo.user_name || "User";

//   const isManagement = userRole === "admin";
//   // const isAdmin = userRole === "admin";

//   // ── Masters ──
//   const [plants, setPlants] = useState([]);
//   const [depots, setDepots] = useState([]);
//   const [customers, setCustomers] = useState([]);
//   const [products, setProducts] = useState([]);

//   // ── Production state ──
//   const [prodPlant, setProdPlant] = useState("");
//   const [prodData, setProdData] = useState(null);
//   const [prodLoading, setProdLoading] = useState(false);
//   const [prodError, setProdError] = useState(null);

//   // ── Distribution state ──
//   const [distDepot, setDistDepot] = useState("");
//   const [distData, setDistData] = useState(null);
//   const [distLoading, setDistLoading] = useState(false);
//   const [distError, setDistError] = useState(null);

//   // ── Inventory state ──
//   const [invLocation, setInvLocation] = useState("");
//   const [invProd, setInvProd] = useState("");
//   const [invData, setInvData] = useState(null);
//   const [invLoading, setInvLoading] = useState(false);

//   // ── Customer holding state ──
//   const [holdingData, setHoldingData] = useState(null);
//   const [holdingLoading, setHoldingLoading] = useState(false);

//   // ── Fetch masters ──
//   useEffect(() => {
//     async function fetchMasters() {
//       try {
//         const [pd, cd, pld, dd] = await Promise.all([
//           productMasterService.getProductList({ page: 0, size: 999, searchKey: "" }),
//           customerMasterService.getCustomerList({ page: 0, size: 999, searchKey: "" }),
//           plantMasterService.getPlantList({ page: 0, size: 999, searchKey: "" }),
//           depotMasterService.getDepotList({ page: 0, size: 999, searchKey: "" }),
//         ]);
//         setProducts(pd || []); setCustomers(cd || []);
//         setPlants(pld || []); setDepots(dd || []);
//         if (pld?.length) setInvLocation(`plant:${pld[0].plant_id}`);
//         else if (dd?.length) setInvLocation(`depot:${dd[0].depot_id}`);
//         if (pd?.length) setInvProd(String(pd[0].prod_id));
//       } catch (e) { console.error(e); }
//     }
//     fetchMasters();
//   }, []);

//   // ── Fetch production ──
//   useEffect(() => {
//     if (!isManagement) return;
//     setProdLoading(true); setProdError(null);
//     const params = { report_type: "weekly" };
//     if (prodPlant) params.plant_id = prodPlant;
//     axiosClient.get("/dashboard/production", { params })
//       .then((r) => setProdData(r.data))
//       .catch(() => setProdError("Failed to load production data"))
//       .finally(() => setProdLoading(false));
//   }, [prodPlant, isManagement]);

//   // ── Fetch distribution ──
//   useEffect(() => {
//     if (!isManagement) return;
//     setDistLoading(true); setDistError(null);
//     const params = distDepot ? { depot_id: distDepot } : {};
//     axiosClient.get("/dashboard/distribution", { params })
//       .then((r) => setDistData(r.data))
//       .catch(() => setDistError("Failed to load distribution data"))
//       .finally(() => setDistLoading(false));
//   }, [distDepot, isManagement]);

//   // ── Fetch inventory ──
//   useEffect(() => {
//     if (!invLocation || !invProd) return;
//     const [type, id] = invLocation.split(":");
//     const params = { prod_id: invProd };
//     if (type === "plant") params.plant_id = id;
//     else params.depot_id = id;
//     setInvLoading(true);
//     axiosClient.get("/dashboard/inventory", { params })
//       .then((r) => setInvData(r.data || {}))
//       .catch(() => setInvData(null))
//       .finally(() => setInvLoading(false));
//   }, [invLocation, invProd]);

//   // ── Fetch customer holding ──
//   useEffect(() => {
//     if (!isManagement) return;
//     setHoldingLoading(true);
//     axiosClient.get("/dashboard/inventory", { params: {} })
//       .then((r) => setHoldingData(r.data))
//       .catch(() => setHoldingData(null))
//       .finally(() => setHoldingLoading(false));
//   }, [isManagement]);

//   // ── Chart helpers ──
//   const last7Labels = getLast7Labels();
//   const last7Dates = getLast7Dates();

//   const prodChartData = useMemo(() => {
//     if (!prodData?.data) return null;
//     const map = new Map();
//     prodData.data.forEach((d) => d.entry_date && map.set(d.entry_date, d));
//     return {
//       labels: last7Labels,
//       datasets: [
//         { label: "Cylinders Filled", data: last7Dates.map((d) => map.get(d)?.cylinder_count || 0), backgroundColor: "#1C3A5E", borderRadius: 3, barPercentage: 0.7 },
//         { label: "Production (KG)", data: last7Dates.map((d) => map.get(d)?.total_qty_filled || 0), backgroundColor: "#2B6CB0", borderRadius: 3, barPercentage: 0.7 },
//         { label: "Carbide (KG)", data: last7Dates.map((d) => map.get(d)?.carbide || 0), backgroundColor: "#F6AD55", borderRadius: 3, barPercentage: 0.7 },
//         { label: "Acetone (KG)", data: last7Dates.map((d) => map.get(d)?.acetone || 0), backgroundColor: "#FC8181", borderRadius: 3, barPercentage: 0.7 },
//       ],
//     };
//   }, [prodData]);

//   const distChartData = useMemo(() => {
//     if (!Array.isArray(distData) || !distData.length) return null;
//     return {
//       labels: last7Labels,
//       datasets: [
//         { label: "Delivered Cylinders", data: distData.map((d) => d.delivered_cylinders || 0), backgroundColor: "#1C3A5E", borderRadius: 3, barPercentage: 0.7 },
//         { label: "Empties Collected",   data: distData.map((d) => d.empty_cylinders_collected || 0), backgroundColor: "#27AE60", borderRadius: 3, barPercentage: 0.7 },
//         { label: "Sales Returns",       data: distData.map((d) => d.sales_return_cylinders || 0), backgroundColor: "#F6AD55", borderRadius: 3, barPercentage: 0.7 },
//         { label: "Qty Delivered",       data: distData.map((d) => d.total_qty_delivered || 0), backgroundColor: "#FC8181", borderRadius: 3, barPercentage: 0.7 },
//       ],
//     };
//   }, [distData]);

//   const invChartData = useMemo(() => {
//     if (!invData) return null;
//     return {
//       labels: ["Total Cylinders", "Full Cylinders", "Empty Cylinders", "Maintenance"],
//       datasets: [
//         { label: "TGPL",        data: [invData.total?.tgpl||0, invData.full?.tgpl||0, invData.empty?.tgpl||0, 0],          backgroundColor: "#1C3A5E", borderRadius: 3, barPercentage: 0.65 },
//         { label: "Customer",    data: [invData.total?.customer||0, invData.full?.customer||0, invData.empty?.customer||0, 0], backgroundColor: "#4472C4", borderRadius: 3, barPercentage: 0.65 },
//         { label: "Maintenance", data: [0, 0, 0, invData.maintenance||0],                                                     backgroundColor: "#FC8181", borderRadius: 3, barPercentage: 0.65 },
//       ],
//     };
//   }, [invData]);

//   const holdingChartData = useMemo(() => {
//     if (!holdingData) return null;
//     return {
//       labels: ["Within Limit", "Near Limit (80–99%)", "Over Limit"],
//       datasets: [{
//         label: "Customers",
//         data: [holdingData.within||0, holdingData.near||0, holdingData.over||0],
//         backgroundColor: ["#27AE60", "#F6AD55", "#FC8181"],
//         borderRadius: 3, barPercentage: 0.5,
//       }],
//     };
//   }, [holdingData]);

//   // KPI totals
//   const totalCylinders = invData ? (invData.total?.tgpl||0) + (invData.total?.customer||0) : null;
//   const fullCylinders  = invData ? (invData.full?.tgpl||0)  + (invData.full?.customer||0)  : null;
//   const todayDelivered = Array.isArray(distData) && distData.length ? distData[distData.length - 1]?.delivered_cylinders : null;

//   const combinedLocations = useMemo(() => [
//     ...plants.map((p) => ({ value: `plant:${p.plant_id}`, label: `🏭 ${p.plant_name}` })),
//     ...depots.map((d) => ({ value: `depot:${d.depot_id}`, label: `🏬 ${d.depot_name}` })),
//   ], [plants, depots]);

//   const holdingWithin = holdingData?.within || 0;
//   const holdingNear   = holdingData?.near   || 0;
//   const holdingOver   = holdingData?.over   || 0;
//   const holdingTotal  = holdingWithin + holdingNear + holdingOver || 1;

//   // ── Styles ──
//   const rootSx = {
//     fontFamily: "'Inter', Arial, sans-serif",
//     background: "#F4F7FB",
//     minHeight: "100vh",
//     padding: "20px 22px 32px",
//   };

//   const bannerSx = {
//     background: "#1C3A5E",
//     borderRadius: "14px",
//     padding: "20px 26px",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//     mb: 3,
//     position: "relative",
//     overflow: "hidden",
//   };

//   return (
//     <Box sx={rootSx}>

//       {/* ── Banner ── */}
//       <Box sx={bannerSx}>
//         {/* decorative circles */}
//         <Box sx={{ position:"absolute", right:-50, top:-50, width:200, height:200, borderRadius:"50%", background:"rgba(43,108,176,0.25)", pointerEvents:"none" }} />
//         <Box sx={{ position:"absolute", right:100, bottom:-70, width:160, height:160, borderRadius:"50%", background:"rgba(39,174,96,0.1)", pointerEvents:"none" }} />

//         <Box sx={{ display:"flex", alignItems:"center", gap:2, position:"relative", zIndex:1 }}>
//           <Box
//             component="img" src={tri_gases} alt="Tri Gases"
//             sx={{ width:56, height:56, borderRadius:"12px", objectFit:"cover", border:"3px solid rgba(255,255,255,0.15)" }}
//           />
//           <Box>
//             <Box sx={{ fontSize:"11px", color:"rgba(255,255,255,0.55)", mb:"2px" }}>{greeting()},</Box>
//             <Box sx={{ fontSize:"20px", fontWeight:700, color:"#fff", lineHeight:1.15 }}>{userName}</Box>
//             <Box sx={{ fontSize:"11px", color:"rgba(255,255,255,0.5)", mt:"3px", textTransform:"uppercase", letterSpacing:"0.5px" }}>
//               {userRole} · CYL Tracking System
//             </Box>
//           </Box>
//         </Box>

//         <Box sx={{ display:"flex", flexDirection:"column", alignItems:"flex-end", gap:"4px", position:"relative", zIndex:1 }}>
//           <Box sx={{ fontSize:"12px", color:"rgba(255,255,255,0.55)" }}>
//             {new Date().toLocaleDateString("en-IN", { weekday:"long", day:"numeric", month:"long", year:"numeric" })}
//           </Box>
//           <Box sx={{ fontSize:"11px", color:"#7DC052" }}>Tri Gases Pvt. Ltd.</Box>
//         </Box>
//       </Box>

//       {isManagement ? (
//         <>
//           {/* ── KPI Strip ── */}
//           <SectionLabel>Overview</SectionLabel>
//           <Grid container spacing={2} sx={{ mb: 3 }}>
//             <Grid item xs={12} sm={6} md={3}>
//               <KpiCard icon={<IcoCylinder />} label="Total Cylinders" value={totalCylinders !== null ? totalCylinders.toLocaleString() : "—"} sub="All plants & depots" iconBg="#E6F1FB" />
//             </Grid>
//             <Grid item xs={12} sm={6} md={3}>
//               <KpiCard icon={<IcoBox c="#155724" />} label="Full Cylinders" value={fullCylinders !== null ? fullCylinders.toLocaleString() : "—"} sub="Ready for delivery" iconBg="#D4EDDA" valueColor="#155724" />
//             </Grid>
//             <Grid item xs={12} sm={6} md={3}>
//               <KpiCard icon={<IcoTruck />} label="Delivered Today" value={todayDelivered !== null ? todayDelivered : "—"} sub="Latest distribution" iconBg="#FFF3CD" valueColor="#856404" />
//             </Grid>
//             <Grid item xs={12} sm={6} md={3}>
//               <KpiCard icon={<IcoCustomers />} label="Total Customers" value={customers?.length ?? "—"} sub="Active accounts" iconBg="#F3E8FF" valueColor="#6B21A8" />
//             </Grid>
//           </Grid>

//           {/* ── Charts Row 1 ── */}
//           <SectionLabel>Production & Distribution Overview</SectionLabel>
//           <Grid container spacing={2} sx={{ mb: 3 }}>

//             {/* Production */}
//             <Grid item xs={12} lg={6}>
//               <ChartCard
//                 title="Production Summary"
//                 sub="Last 7 days · filling data by plant"
//                 badge="Weekly"
//                 badgeColor="blue"
//                 loading={prodLoading}
//                 error={prodError}
//                 filters={
//                   <Box sx={{ display:"flex", gap:1, mb:1.5, flexWrap:"wrap" }}>
//                     <FilterSelect
//                       label="Plant" value={prodPlant} onChange={setProdPlant} allLabel="Plants"
//                       items={plants.map((p) => ({ value: p.plant_id, label: p.plant_name }))}
//                     />
//                   </Box>
//                 }
//                 legend={[
//                   { label:"Cylinders Filled", color:"#1C3A5E" },
//                   { label:"Production (KG)",  color:"#2B6CB0" },
//                   { label:"Carbide (KG)",     color:"#F6AD55" },
//                   { label:"Acetone (KG)",     color:"#FC8181" },
//                 ]}
//               >
//                 {prodChartData
//                   ? <Box sx={{ height:230, position:"relative" }}><Bar data={prodChartData} options={BASE_CHART_OPTS} /></Box>
//                   : <Box sx={{ fontSize:"13px", color:"#718096", p:2 }}>No production data available for this period.</Box>
//                 }
//               </ChartCard>
//             </Grid>

//             {/* Distribution */}
//             <Grid item xs={12} lg={6}>
//               <ChartCard
//                 title="Distribution Summary"
//                 sub="Last 7 days · delivery & collection"
//                 badge="Active"
//                 badgeColor="green"
//                 loading={distLoading}
//                 error={distError}
//                 filters={
//                   <Box sx={{ display:"flex", gap:1, mb:1.5, flexWrap:"wrap" }}>
//                     <FilterSelect
//                       label="Depot" value={distDepot} onChange={setDistDepot} allLabel="Depots"
//                       items={depots.map((d) => ({ value: d.depot_id, label: d.depot_name }))}
//                     />
//                   </Box>
//                 }
//                 legend={[
//                   { label:"Delivered Cylinders", color:"#1C3A5E" },
//                   { label:"Empties Collected",   color:"#27AE60" },
//                   { label:"Sales Returns",       color:"#F6AD55" },
//                   { label:"Qty Delivered",       color:"#FC8181" },
//                 ]}
//               >
//                 {distChartData
//                   ? <Box sx={{ height:230, position:"relative" }}><Bar data={distChartData} options={BASE_CHART_OPTS} /></Box>
//                   : <Box sx={{ fontSize:"13px", color:"#718096", p:2 }}>No distribution data available.</Box>
//                 }
//               </ChartCard>
//             </Grid>
//           </Grid>

//           {/* ── Charts Row 2 ── */}
//           <SectionLabel>Inventory & Customer Holding</SectionLabel>
//           <Grid container spacing={2}>

//             {/* Inventory */}
//             <Grid item xs={12} lg={6}>
//               <ChartCard
//                 title="Cylinder Inventory"
//                 sub="Snapshot by location & product"
//                 badge="Live"
//                 badgeColor="blue"
//                 loading={invLoading}
//                 filters={
//                   <Box sx={{ display:"flex", gap:1, mb:1.5, flexWrap:"wrap" }}>
//                     <FilterSelect
//                       label="Location" value={invLocation} onChange={setInvLocation} allLabel="Locations"
//                       items={combinedLocations}
//                     />
//                     <FilterSelect
//                       label="Product" value={invProd} onChange={setInvProd} allLabel="Products"
//                       items={products.map((p) => ({ value: p.prod_id, label: p.prod_name }))}
//                     />
//                   </Box>
//                 }
//                 legend={[
//                   { label:"TGPL",        color:"#1C3A5E" },
//                   { label:"Customer",    color:"#4472C4" },
//                   { label:"Maintenance", color:"#FC8181" },
//                 ]}
//                 bottomSlot={
//                   invData && (
//                     <Grid container spacing={1.5} sx={{ mt:1.5 }}>
//                       <Grid item xs={6}>
//                         <Box sx={{ background:"#F8FAFC", borderRadius:"8px", p:"10px 14px", border:"1px solid #E2E8F0" }}>
//                           <Box sx={{ fontSize:"18px", fontWeight:700, color:"#1C3A5E" }}>{((invData.total?.tgpl||0)).toLocaleString()}</Box>
//                           <Box sx={{ fontSize:"11px", color:"#718096", mt:"2px" }}>TGPL Cylinders</Box>
//                         </Box>
//                       </Grid>
//                       <Grid item xs={6}>
//                         <Box sx={{ background:"#F8FAFC", borderRadius:"8px", p:"10px 14px", border:"1px solid #E2E8F0" }}>
//                           <Box sx={{ fontSize:"18px", fontWeight:700, color:"#1C3A5E" }}>{((invData.total?.customer||0)).toLocaleString()}</Box>
//                           <Box sx={{ fontSize:"11px", color:"#718096", mt:"2px" }}>Customer Cylinders</Box>
//                         </Box>
//                       </Grid>
//                     </Grid>
//                   )
//                 }
//               >
//                 {invChartData
//                   ? <Box sx={{ height:200, position:"relative" }}><Bar data={invChartData} options={BASE_CHART_OPTS} /></Box>
//                   : <Box sx={{ fontSize:"13px", color:"#718096", p:2 }}>Select a location and product to view inventory.</Box>
//                 }
//               </ChartCard>
//             </Grid>

//             {/* Customer Holding */}
//             <Grid item xs={12} lg={6}>
//               <ChartCard
//                 title="Customer Holding"
//                 sub="Current period overview"
//                 badge="Updated"
//                 badgeColor="green"
//                 loading={holdingLoading}
//                 filters={
//                   <Box sx={{ display:"flex", gap:1, mb:1.5, flexWrap:"wrap" }}>
//                     <FilterSelect
//                       label="Location" value={invLocation} onChange={setInvLocation} allLabel="Locations"
//                       items={combinedLocations}
//                     />
//                   </Box>
//                 }
//                 legend={[
//                   { label:"Within Limit", color:"#27AE60" },
//                   { label:"Near Limit",   color:"#F6AD55" },
//                   { label:"Over Limit",   color:"#FC8181" },
//                 ]}
//                 bottomSlot={
//                   holdingData && (
//                     <Box sx={{ mt:1.5 }}>
//                       <ProgBar label="Within Limit"          value={holdingWithin} total={holdingTotal} color="#27AE60" textColor="#155724" />
//                       <ProgBar label="Near Limit (80–99%)"   value={holdingNear}   total={holdingTotal} color="#F6AD55" textColor="#856404" />
//                       <ProgBar label="Over Limit"            value={holdingOver}   total={holdingTotal} color="#FC8181" textColor="#C53030" />
//                     </Box>
//                   )
//                 }
//               >
//                 {holdingChartData
//                   ? <Box sx={{ height:200, position:"relative" }}><Bar data={holdingChartData} options={{ ...BASE_CHART_OPTS, plugins: { ...BASE_CHART_OPTS.plugins, legend: { display:false } } }} /></Box>
//                   : <Box sx={{ fontSize:"13px", color:"#718096", p:2 }}>Select a location to view customer holding data.</Box>
//                 }
//               </ChartCard>
//             </Grid>
//           </Grid>
//         </>
//       ) : (
//         /* Non-management roles */
//         <Box sx={{ display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", minHeight:"400px", gap:2 }}>
//           <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#CBD5E0" strokeWidth="1.5">
//             <rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/>
//             <rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/>
//           </svg>
//           <Box sx={{ fontSize:"15px", color:"#718096", fontWeight:500 }}>
//             Welcome, {userName}! Use the sidebar to navigate to your modules.
//           </Box>
//         </Box>
//       )}
//     </Box>
//   );
// };

// export default Dashboard;

import React, { useMemo } from "react";
import { Box } from "@mui/material";
import AdminDashboard from "./Admindashboard";
import PlantDashboard from "./Plantdashboard ";
import styles from "../../styles.module.css";
import ManagementDashboard from "./ManagementDashboard";
import DepotDashboard from "./DepotDashboard";
import SalesOfficerDashboard from "./Salesofficerdashboard";

const noAccessImage = require("../../images/home.png");

const Dashboard = () => {
  const userRole = useMemo(() => {
    try {
      const d = JSON.parse(sessionStorage.getItem("loginUser") || "{}");
      return d?.result?.userInfo?.user_role || "";
    } catch {
      return "";
    }
  }, []);

  // const renderDashboard = () => {
  //   switch (userRole) {
  //     case "admin":
  //       return <AdminDashboard />;
  //     case "plant":
  //       return <PlantDashboard />;
  //     // Other roles to be added: management, depot, sales, logistics
  //     default:
  //       return (
  //         <Box display="flex" justifyContent="center" alignItems="center" height="400px">
  //           <img src={noAccessImage} alt="No dashboard available" />
  //         </Box>
  //       );
  //   }
  // };
const renderDashboard = () => {
    switch (userRole) {
      case "admin":
        return <AdminDashboard />;
      case "plant":
        return <PlantDashboard />;
      case "management":                        // ← add this
        return <ManagementDashboard />; 
        case "depot":
  return <DepotDashboard />;   
        case "sales":
  return <SalesOfficerDashboard />; 
      default:
        return (
          <Box display="flex" justifyContent="center" alignItems="center" height="400px">
            <img src={noAccessImage} alt="No dashboard available" />
          </Box>
        );
    }
  };
  return (
    <Box className={styles.cts_page} sx={{ padding: "0px !important", margin: "0px !important" }}>
      <Box className={styles.body}>{renderDashboard()}</Box>
    </Box>
  );
};

export default Dashboard;